import React from 'react';

import RequestSummary from '../../components/RequestSummary/RequestSummary';

class OrderHistory extends React.Component {
    render() {
        const {requests, currentUser} = this.props;

        const renderRequests = requests
            .sort((a, b) => {
                return b.requestInfo.requestDate - a.requestInfo.requestDate;
            })
            .map((request, i) => {
            return (
                <RequestSummary {...request} key={i} isAdmin={!!(currentUser.permission)}/>
            );
        });

        return (
            <div>
                <h1>Request History</h1>
                <hr />
                {renderRequests}
            </div>
        );
    }
}

// OrderHistory.propTypes = {
//     requests: React.PropTypes.array
// };

export default OrderHistory



/** WEBPACK FOOTER **
 ** ./src/components/OrderHistory/OrderHistory.js
 **/